import { createRoot } from "react-dom/client";
import CommonModal from "views/components/CommonModal";
import styles from "./device-modal.module.less";

// 创建一个显示弹窗的函数
export const showDeviceModal = (props = {}) => {
  const {
    message = "",
    onConfirm = () => {},
    onCancel = () => {},
    onClose = () => {},
    cancelText = "取消",
    confirmText = "确认",
    isShowCancel = false,
    isShowConfirm = false,
  } = props;
  const modalId = "device-modal-container";

  const existingModal = document.getElementById(modalId);
  if (existingModal) {
    try {
      document.body.removeChild(existingModal);
    } catch (error) {
      console.warn("Failed to remove existing modal:", error);
    }
  }
  const modalDiv = document.createElement("div");
  modalDiv.id = modalId;
  document.body.appendChild(modalDiv);
  const root = createRoot(modalDiv);

  const destroyModal = () => {
    try {
      root.unmount();
    } catch (error) {
      console.warn("Failed to unmount root:", error);
    }

    try {
      if (document.body.contains(modalDiv)) {
        document.body.removeChild(modalDiv);
      }
    } catch (error) {
      console.warn("Failed to remove modal div:", error);
    }
  };

  const Modal = () => {
    return (
      <CommonModal isOpen={true}>
        <div className={styles["pop-container"]}>
          <div className={styles["pop-wrapper"]}>
            <div className={styles["pop-wrapper-title"]}>温馨提示</div>
            <div className={styles["pop-wrapper-text"]}>{message}</div>
            <div className={styles["pop-wrapper-button"]}>
              {isShowCancel && (
                <div
                  className={`${styles["button-item"]} ${styles["button-cancel"]}`}
                  onClick={() => {
                    onCancel();
                    destroyModal();
                  }}
                >
                  {cancelText}
                </div>
              )}
              {isShowConfirm && (
                <div
                  className={`${styles["button-item"]} ${styles["button-confirm"]}`}
                  onClick={() => {
                    onConfirm();
                    destroyModal();
                  }}
                >
                  {confirmText}
                </div>
              )}
            </div>
          </div>
          <img
            onClick={() => {
              onClose();
              destroyModal();
            }}
            className={styles["modal-close"]}
            src={require("@/images/mine/recommend-officer/button_cancel.png")}
          />
        </div>
      </CommonModal>
    );
  };

  root.render(<Modal />);

  // 返回销毁函数，以便在需要时手动销毁
  return destroyModal;
};
